import { useQuery } from '@tanstack/react-query';

import { getHomeDashboard } from '~apis/home';

export const HomeQueryKey = {
  default: () => ['home'],
  dashboard: ({
    companyId,
    startDate,
    endDate,
  }: {
    companyId: string;
    startDate?: string;
    endDate?: string;
  }) => [...HomeQueryKey.default(), 'dashboard', companyId, startDate, endDate],
};

export const useGetHomeDashboard = ({
  companyId,
  startDate,
  endDate,
}: {
  companyId: string;
  startDate?: string;
  endDate?: string;
}) => {
  return useQuery({
    queryKey: HomeQueryKey.dashboard({ companyId, startDate, endDate }),
    queryFn: () => getHomeDashboard({ companyId, startDate, endDate }),
    enabled: !!companyId,
    keepPreviousData: true,
  });
};
